var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"questionnaire-inquiry v-hoverable",on:{"click":_setup.handleClick}},[_c('el-image',{staticStyle:{"width":"14px","height":"14px"},attrs:{"src":"https://imagecdn.ymm56.com/ymmfile/static/resource/92c195f2-c55e-4683-a0e2-0a846386dbdc.png","fit":"fit"}}),_c('span',[_vm._v("问卷调研")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }